const LINES = [
  "JVNKO BIOS 4.20",
  "copyright (c) helm, jvnko.boats",
  "",
  "cpu     : phosphor core / 1 thread of spite",
  "mem     : enough",
  "display : CRT 80x24  ·  sonar overlay",
  "",
  "checking mx route ................... ok",
  "checking beatmap cache ............. ok",
  "checking matrix federation ......... ok",
  "raising A @ jvnko.boats ............ helm",
  "",
  "boot device: tty01",
  "starting jvnko@boats ...",
];

export async function playBoot(log: HTMLElement, signal: AbortSignal): Promise<void> {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  for (const line of LINES) {
    if (signal.aborted) return;
    await typeLine(log, line, reduce ? 0 : 9 + Math.random() * 12, signal);
    if (!reduce) await sleep(40 + Math.random() * 70, signal);
  }
  if (!reduce) await sleep(280, signal);
}

function typeLine(log: HTMLElement, line: string, chDelay: number, signal: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    const row = document.createElement("div");
    log.append(row);
    log.parentElement?.scrollTo({ top: 99999 });
    if (chDelay <= 0) {
      row.textContent = line || " ";
      resolve();
      return;
    }
    let i = 0;
    const tick = () => {
      if (signal.aborted) {
        reject(new DOMException("aborted", "AbortError"));
        return;
      }
      row.textContent = line.slice(0, i) || (i === 0 ? "" : line);
      i += 1;
      if (i > line.length) {
        resolve();
        return;
      }
      window.setTimeout(tick, chDelay);
    };
    tick();
  });
}

function sleep(ms: number, signal: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    const t = window.setTimeout(resolve, ms);
    signal.addEventListener(
      "abort",
      () => {
        window.clearTimeout(t);
        reject(new DOMException("aborted", "AbortError"));
      },
      { once: true },
    );
  });
}
